const links = [
  { href: "#approach", label: "DPDP Approach" },
  { href: "#anumati", label: "Anumati" },
  { href: "#engagement", label: "Engagement" },
  { href: "#why-dhwani", label: "Why Dhwani" },
];

export const Header = () => (
  <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-[#E7E7EC]">
    <div className="max-w-[1120px] mx-auto px-6 h-[66px] flex items-center gap-8">
      <a href="#top" data-testid="header-logo" className="flex items-center gap-2.5">
        <img src="/dhwani-logo.png" alt="Dhwani Rural Information Systems" className="h-10 w-auto" />
        <span className="hidden sm:inline text-[#9498A3] font-medium text-lg">· DPDP</span>
      </a>
      <nav className="hidden md:flex gap-7 text-[14.5px] font-medium text-[#5C5F6B]">
        {links.map((l) => (
          <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="hover:text-[#0B0B0F] transition-colors">
            {l.label}
          </a>
        ))}
      </nav>
      <a
        href="#contact"
        data-testid="header-contact-btn"
        className="ml-auto inline-flex items-center px-5 py-2.5 rounded-[10px] bg-[#9E1B32] text-white text-sm font-semibold shadow-[0_4px_12px_-2px_rgba(158,27,50,0.4)] hover:bg-[#7A1426] hover:-translate-y-px transition-[background-color,transform]"
      >
        Contact Us
      </a>
    </div>
  </header>
);

export default Header;
